import { Button, Modal, ModalCloseButton, ModalDescription, ModalFooter, ModalHeader, type ModalProps, ModalTitle } from '@tryhackme/thm-ui-components';
import type { SmallModalProps } from './standard-action-modal.types';
export const StandardActionModal = ({
  modalTitleText,
  modalBodyText,
  actionButtonTitle,
  dismissButtonTitle,
  handleModalAction,
  triggerElement,
  children,
  iconComponent,
  showIcon = false,
  showDismissButton = true,
  showActionButton = true,
  actionButtonColor = 'error',
  actionButtonVariant = 'solid',
  actionLoading,
  onOpenChange,
  open,
  handleCloseButtonAction,
  stepModal = false,
  isSmall = true,
  ...otherModalProps
}: ModalProps & SmallModalProps) => {
  const handleAction = () => {
    if (onOpenChange) onOpenChange(stepModal);
    handleModalAction?.();
  };
  return <Modal open={open} onOpenChange={onOpenChange} {...otherModalProps} handleCloseButtonAction={handleCloseButtonAction} isSmall={isSmall} data-sentry-element="Modal" data-sentry-component="StandardActionModal" data-sentry-source-file="standard-action-modal.tsx">
      <ModalHeader isSmall={isSmall} data-sentry-element="ModalHeader" data-sentry-source-file="standard-action-modal.tsx">
        {showIcon && iconComponent}
        <ModalTitle isSmall={isSmall} data-sentry-element="ModalTitle" data-sentry-source-file="standard-action-modal.tsx">{modalTitleText}</ModalTitle>
      </ModalHeader>

      <ModalDescription data-sentry-element="ModalDescription" data-sentry-source-file="standard-action-modal.tsx">{modalBodyText}</ModalDescription>

      {children}

      <ModalFooter isSmall={isSmall} data-sentry-element="ModalFooter" data-sentry-source-file="standard-action-modal.tsx">
        {showDismissButton && <ModalCloseButton handleCloseButtonAction={handleCloseButtonAction} text={dismissButtonTitle} />}
        {showActionButton && <Button variant={actionButtonVariant} color={actionButtonColor} onClick={handleAction} isLoading={actionLoading} disabled={actionLoading}>
            {actionButtonTitle}
          </Button>}
      </ModalFooter>
    </Modal>;
};